import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';
import { authReducer, AuthState } from './features/auth/state/auth.reducer';
import { homeReducer, HomeState } from './features/home/state/home.reducer';
import { adminReducer, AdminState } from './features/admin/state/admin.reducer';

export interface AppState {
  auth: AuthState;
  home: HomeState;
  admin: AdminState;
}

export const reducers: ActionReducerMap<AppState> = {
  auth: authReducer,
  home: homeReducer,
  admin: adminReducer,
};

export function localStorageSyncReducer(
  reducer: ActionReducer<AppState>,
): ActionReducer<AppState> {
  return localStorageSync({
    keys: [
      { auth: ['user', 'token'] },
      {
        home: ['uploadedFiles', 'convertedFiles', 'gerberFiles', 'lectraFiles'],
      },
      { admin: ['convertedFiles'] },
    ],
    rehydrate: true,
  })(reducer);
}

export const metaReducers: Array<MetaReducer<any, any>> = [
  localStorageSyncReducer,
];
